'use es6';

import createAction from 'flux-actions/createAction';
import { RECEIVED_STYLESHEETS, REQUESTED_STYLESHEETS, REQUESTED_STYLESHEETS_FAILED } from './ActionTypes';
export const requestStylesheets = createAction(REQUESTED_STYLESHEETS);
export const receiveStylesheets = createAction(RECEIVED_STYLESHEETS, stylesheets => ({
  stylesheets
}));
export const requestedStylesheetsFailed = createAction(REQUESTED_STYLESHEETS_FAILED, error => ({
  error
}));